import { render } from "./adList.vue?vue&type=template&id=63e387f0&ts=true"
import script from "./adList.vue?vue&type=script&lang=ts&config=true"
export * from "./adList.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__